document.addEventListener("DOMContentLoaded", () => {
  customColorSwatchChannge();
});
function customColorSwatchChannge(){
  document.querySelectorAll(".color-swatch, .thumbnail-swatch").forEach((swatch) => {
    swatch.addEventListener("click", function (event) {
      event.preventDefault();
      
      // Manage active class
      const fieldset = this.closest("fieldset");
      if (fieldset) {
        fieldset.querySelectorAll(".color-swatch, .thumbnail-swatch").forEach((s) =>
          s.classList.remove("active")
        );
      }
      this.classList.add("active");
      
      const imageUrl = this.dataset.image;
      const productCard = this.closest(".card-wrapper");
      const imageElement = productCard.querySelector("img");
      const aElements = productCard.querySelectorAll("a");

      const inputId = swatch.getAttribute('for');
      const input = document.getElementById(inputId);
      if (!input) return;

      const mediaData = input.getAttribute('data-variant-media');
      const variantHref = input.getAttribute('data-href');
      if (!mediaData) return;
      aElements.forEach((aElement) => {
        aElement.href= variantHref;
      });

      const mediaData2 = input.getAttribute('data-variant-next-media');
      
      try {
        const media = JSON.parse(mediaData.replace(/&quot;/g, '"'));
        const imageUrl = media?.src;
        if (!imageUrl) return;

        const productCard = swatch.closest('.card-wrapper');
        const imageEl = productCard.querySelector('img');

        if (imageEl) {
          imageEl.src = imageUrl;
          //imageEl.dataset.original = imageUrl;

          const imageId = media?.id;
          if (imageId) {
              // If Shopify CDN format: rebuild srcset
              const baseUrl = imageUrl.split('?')[0].replace(/_[0-9]+x\./, '.'); // strip size if present
  
              const srcset = [
                `${baseUrl}?width=165 165w`,
                `${baseUrl}?width=360 360w`,
                `${baseUrl}?width=533 533w`,
                `${baseUrl}?width=720 720w`,
                `${baseUrl}?width=940 940w`,
                `${baseUrl}?width=1066 1066w`
              ].join(', ');
  
              imageEl.setAttribute('srcset', srcset);
          }
        }
      } catch (e) {
        console.error('Invalid JSON in data-variant-media:', e);
      }


      //AK custom code
      if (!mediaData2) return;
      try {
        const media = JSON.parse(mediaData2.replace(/&quot;/g, '"'));
        const imageUrl = media?.src;
        if (!imageUrl) return;

        const productCard = swatch.closest('.card-wrapper');
        const imageEl = productCard.querySelector('img.second_img');

        if (imageEl) {
          imageEl.src = imageUrl;
          //imageEl.dataset.original = imageUrl;

          const imageId = media?.id;
          if (imageId) {
              // If Shopify CDN format: rebuild srcset
              const baseUrl = imageUrl.split('?')[0].replace(/_[0-9]+x\./, '.'); // strip size if present
  
              const srcset = [
                `${baseUrl}?width=165 165w`,
                `${baseUrl}?width=360 360w`,
                `${baseUrl}?width=533 533w`,
                `${baseUrl}?width=720 720w`,
                `${baseUrl}?width=940 940w`,
                `${baseUrl}?width=1066 1066w`
              ].join(', ');
  
              imageEl.setAttribute('srcset', srcset);
          }
        }
      } catch (e) {
        console.error('Invalid JSON in data-variant-media:', e);
      }

      //end AK custom code

    });
  });
}

